export const PRIMARY_BLUE = "#03aeec";
export const DARK_BLUE = "#004e98";
export const CRIMSON_RED = "#c1121f";
export const BG_COLOR = "#1E1E1E";
export const PINK = "pink";
export const HOT_PINK = "hotpink";
export const SUCCESS_PRIMARY_MUI = "#2e7d32";
